import { render, staticRenderFns } from "./SecurityDepositPaymentForm.vue?vue&type=template&id=0b122110&"
import script from "./SecurityDepositPaymentForm.vue?vue&type=script&lang=js&"
export * from "./SecurityDepositPaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./SecurityDepositPaymentForm.vue?vue&type=style&index=0&id=0b122110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports